/**
 * outlive-colecao.js — filtro por categoria, "ver mais" e cascata de entrada
 * da seção sections/outlive-colecao.liquid.
 *
 * Um card pode estar escondido por DOIS motivos independentes: o filtro
 * (categoria não selecionada) e o limite (passou da quantidade inicial). Se
 * cada um mexesse no atributo `hidden` por conta própria, um desfaria o outro —
 * filtrar mostraria cards que o limite tinha escondido, e vice-versa. Por isso
 * ninguém liga/desliga nada direto: os dois só mudam estado, e `aplicar()`
 * recalcula a visibilidade de todo mundo a partir dos dois juntos.
 *
 * O limite é contado sobre o conjunto JÁ FILTRADO. Trocar de categoria zera o
 * "ver mais" — senão, uma categoria com 3 itens herdaria o botão de uma
 * categoria com 40 e mostraria "ver mais 37" sem ter o que mostrar.
 */
(function () {
  var MOBILE = '(max-width: 999px)'

  function init(raiz) {
    if (raiz.dataset.ocPronto) return
    raiz.dataset.ocPronto = '1'

    var grade = raiz.querySelector('.oc-grade')
    if (!grade) return

    /* SÓ os cards no primeiro nível da grade entram no filtro e no limite.
       Kits dentro da faixa (.oc-kits) são cuidados pela faixa como um todo — se
       entrassem aqui, o "ver mais" contaria cada um e poderia esconder metade de
       uma faixa, deixando um título sobre kit nenhum. */
    var cards = Array.prototype.slice.call(grade.querySelectorAll(':scope > .oc-card'))

    /* Para as chips, porém, vale TODO card, aninhado ou não: a categoria de um
       kit dentro da faixa também merece virar filtro. */
    montarChips(raiz, Array.prototype.slice.call(raiz.querySelectorAll('.oc-card, .oc-kits')))

    /* Blocos que ocupam a linha inteira — título solto e faixa de kits.
       Respeitam o filtro por categoria, mas nunca o limite do "ver mais": ele
       existe para encurtar a lista de PRODUTOS, e cortar um desses deixaria o
       trecho seguinte sem a linha que o apresenta. */
    var blocos = Array.prototype.slice.call(raiz.querySelectorAll('.oc-titulo, .oc-kits'))

    var tituloGrande = raiz.querySelector('.oc-head__titulo')
    var tituloOriginal = tituloGrande ? tituloGrande.innerHTML : null
    var seguirFiltro = raiz.hasAttribute('data-titulo-segue-filtro')

    var chips = Array.prototype.slice.call(raiz.querySelectorAll('.oc-filtro__chip'))
    var caixaMais = raiz.querySelector('.oc-mais')
    var btnMais = raiz.querySelector('.oc-mais__btn')
    var modeloVarios = raiz.dataset.rotuloMais || 'Ver mais {n} produtos'
    /* Português não pluraliza só com "s" (opção/opções), então o singular vem
       escrito do editor em vez de derivado do plural. Sem ele, cai no plural. */
    var modeloUm = raiz.dataset.rotuloMaisUm || modeloVarios

    var categoria = ''
    var expandido = false

    function limite() {
      var mob = window.matchMedia(MOBILE).matches
      var n = parseInt(mob ? raiz.dataset.mostrarMobile : raiz.dataset.mostrarDesktop, 10)
      return isNaN(n) ? cards.length : n
    }

    function aplicar() {
      var visiveis = cards.filter(function (c) {
        return !categoria || c.dataset.cat === categoria
      })

      var teto = expandido ? visiveis.length : limite()

      cards.forEach(function (c) {
        var pos = visiveis.indexOf(c)
        var mostra = pos !== -1 && pos < teto
        c.hidden = !mostra
        /* Índice da cascata conta só quem aparece, senão os primeiros visíveis
           herdariam o atraso de cards escondidos e entrariam tarde demais. */
        if (mostra) c.style.setProperty('--oc-i', pos % 12)
      })

      blocos.forEach(function (t) {
        var cat = (t.dataset.cat || '').trim()
        /* Sem categoria = aparece sempre. Com categoria = só na dela e em "Todos". */
        t.hidden = !!(categoria && cat && cat !== categoria)
      })

      var faltam = visiveis.length - teto
      if (caixaMais) {
        caixaMais.hidden = faltam <= 0
        if (btnMais && faltam > 0)
          btnMais.textContent = (faltam === 1 ? modeloUm : modeloVarios).replace('{n}', faltam)
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        categoria = chip.dataset.cat || ''
        expandido = false
        chips.forEach(function (o) {
          o.setAttribute('aria-pressed', o === chip ? 'true' : 'false')
        })
        trocarTitulo()
        aplicar()
      })
    })

    /* O título grande vira o nome da categoria escolhida. O original é guardado
       como innerHTML porque pode conter <em> (a palavra em destaque); o nome da
       categoria entra como texto, via textContent, para não injetar marcação
       vinda de um campo do editor. */
    function trocarTitulo() {
      if (!seguirFiltro || !tituloGrande) return
      if (categoria) tituloGrande.textContent = categoria
      else tituloGrande.innerHTML = tituloOriginal
    }

    if (btnMais) {
      btnMais.addEventListener('click', function () {
        expandido = true
        aplicar()
      })
    }

    /* O limite depende da largura, então girar o celular precisa recalcular.
       O gatilho é 'resize', não o evento 'change' do matchMedia: medido aqui,
       o change não dispara de forma confiável quando a viewport muda por
       emulação, e o sintoma é silencioso — a grade vira 2 colunas mas segue
       mostrando a quantidade do computador.

       Só recalcula quando o lado da fronteira muda de verdade. Redimensionar
       de 1200 para 1100 não mexe em nada, então não há motivo para trabalho a
       cada pixel de arrasto — e por isso também não precisa de debounce. */
    var eraMobile = window.matchMedia(MOBILE).matches
    window.addEventListener(
      'resize',
      function () {
        var agora = window.matchMedia(MOBILE).matches
        if (agora === eraMobile) return
        eraMobile = agora
        aplicar()
      },
      { passive: true }
    )

    aplicar()
    revelar(raiz)
  }

  /**
   * Monta as chips do filtro a partir das categorias que os cards carregam.
   *
   * Por que aqui e não no Liquid da seção: bloco de tema é opaco para a seção
   * pai — percorrer section.blocks devolve os blocos, mas com type "@theme" e
   * settings vazio, então a categoria não é legível de lá. Ela só aparece no
   * data-cat que o próprio bloco imprime. O efeito prático para quem edita é o
   * mesmo: escreveu a categoria no card, virou chip, sem lista para manter.
   *
   * A ordem das chips segue a ordem dos cards na página, não alfabética — assim
   * quem organiza a vitrine também organiza o filtro.
   */
  function montarChips(raiz, elementos) {
    var barra = raiz.querySelector('.oc-filtro[data-monta-chips]')
    if (!barra) return

    var vistas = []
    elementos.forEach(function (c) {
      var cat = (c.dataset.cat || '').trim()
      if (cat && vistas.indexOf(cat) === -1) vistas.push(cat)
    })

    /* Uma categoria só não é filtro: todos os cards cairiam nela e o chip
       "Todos" faria exatamente o mesmo. Nesse caso a barra nem aparece. */
    if (vistas.length < 2) {
      barra.hidden = true
      return
    }

    vistas.forEach(function (cat) {
      var b = document.createElement('button')
      b.className = 'oc-filtro__chip'
      b.type = 'button'
      b.dataset.cat = cat
      b.setAttribute('aria-pressed', 'false')
      b.textContent = cat
      barra.appendChild(b)
    })

    barra.hidden = false
  }

  /* Cascata: a seção inteira entra de uma vez e os cards se sucedem por atraso
     fixo — o mesmo tratamento das tabelas comparativas. Rolagem item a item não
     serviria aqui: numa grade de 4 colunas cabem 8 cards por tela, então o
     gatilho dispararia com quase tudo já visível. */
  function revelar(raiz) {
    if (!raiz.hasAttribute('data-anima')) return

    var semMovimento =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (semMovimento || !('IntersectionObserver' in window)) {
      raiz.classList.add('oc--visivel')
      return
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return
          e.target.classList.add('oc--visivel')
          obs.unobserve(e.target)
        })
      },
      /* rootMargin generoso no topo pelo mesmo motivo do scroll-reveal do tema:
         quem chega com a página já rolada (âncora, voltar do navegador) passaria
         da seção sem nunca cruzar o limiar, e ela ficaria invisível para sempre. */
      { rootMargin: '100000px 0px -8% 0px' }
    )
    obs.observe(raiz)

    /* Failsafe: se por qualquer motivo o observer não disparar em 5s, o
       conteúdo aparece. Nunca esconder sem garantia de revelar. */
    setTimeout(function () {
      raiz.classList.add('oc--visivel')
    }, 5000)
  }

  function tudo(escopo) {
    ;(escopo || document).querySelectorAll('.oc').forEach(init)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      tudo()
    })
  } else {
    tudo()
  }

  /* Editor de temas: a seção é re-renderizada a cada mudança. */
  document.addEventListener('shopify:section:load', function (e) {
    tudo(e.target)
  })

  /* Editor: ao selecionar um bloco, ele precisa estar à vista — senão a pessoa
     clica no card na lista lateral e não vê nada acontecer porque o filtro ou o
     "ver mais" o deixou escondido. */
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest ? e.target.closest('.oc-card') : null
    if (!card || !card.hidden) return
    var raiz = card.closest('.oc')
    if (!raiz) return
    var btn = raiz.querySelector('.oc-mais__btn')
    var todos = raiz.querySelector('.oc-filtro__chip[data-cat=""]')
    if (todos) todos.click()
    if (btn) btn.click()
    card.scrollIntoView({ block: 'center', behavior: 'smooth' })
  })
})()
